export default "__VITE_ASSET__0_9xLrYz__"